import styled from "styled-components";

export const InfoModalBody = styled.div`
  padding: 16px 30px 30px;
`;

export const BulletList = styled.ul`
  list-style: none;
  margin: 0 0 30px 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BulletItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const BulletIcon = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #000000;
  flex-shrink: 0;
  margin-top: 8px;
`;

export const BulletText = styled.div`
  font-size: 16px;
  line-height: 1.5;
  color: #000000;
  flex: 1;
`;
